<template>
    <div class="card-data resume-icon">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small class="sub-title">{{sub}}</small>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <div v-else-if="amount == null || amount == 0">
            <EmptyStateChart
            :title="titleEmpty"
            :caption="captionEmpty"
            />
        </div> -->
        <div v-else>
            <div class="icon"  style="text-align: center; align-self: center">
            <img src="@/assets/icons/clock-resume.svg" alt="Clock icon" v-if="icon==0">
            <img src="@/assets/icons/calendar-resume.svg" alt="Clock icon" v-if="icon==1">
        </div>
        <div  style="text-align: center">
            <ICountUp
                :endVal="amount"
                :options="options"
                class="amount-with-icon"
                />
            <p class="detail-with-icon">conexiones</p>
        </div>
        </div>
        
        
        
        
    </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'


export default {
    name: 'AmountSingle',
    components: {
        ICountUp,
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            required: true
        },
        loader: {
            type: Boolean,
            default: false
        },
        tip: {
            type: String,
            default: ''
        },
        icon: {
            type: Number,
            default: 1
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    },
    data: function(){
        return {
            options: {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: '.',
                decimal: ',',
                prefix: '',
                suffix: ''
            }
        }
    },

}
</script>

<style lang="sass">
.resume-icon
    min-width: 184px
    @media (max-width: $tablet)
        min-width: 0px
.card-data
    .icon
        margin: $sm $md
        img
            @media (max-width: $phone)
                width: 64px
                height: 64px
.amount-with-icon
    font-family: Montserrat
    font-size: 32px
    font-weight: 600
    color: #302f2f
    @media (max-width: $phone)
        font-size: 24px
    @include tablet-landscape
        font-size: 24px
    @include tablet-portrait
        font-size: 24px

.detail-with-icon
    font-family: Muli
    font-size: 16px
    color: #302f2f
    margin-bottom: $sm
    @media (max-width: $phone)
        margin-bottom: $sm
</style>